import { render, staticRenderFns } from "./boat-review-simple.vue?vue&type=template&id=18f0e980"
import script from "./boat-review-simple.vue?vue&type=script&lang=js"
export * from "./boat-review-simple.vue?vue&type=script&lang=js"
import style0 from "./boat-review-simple.vue?vue&type=style&index=0&id=18f0e980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports